import { useState } from 'react';
import { toPng } from 'html-to-image';
import { Document, Page, Text, View, Image, StyleSheet, Font, pdf } from '@react-pdf/renderer';


const GroupReportsPDF = ({ selectedSchool, selectedYearGroup, selectedPeriods, groupReportChartRef, selectedInverventionTypes, selectedStudentStatuses, includeLowAttendance, selectedTutorGroupLead, selectedTutorGroup }) => {

    const [pdfLoading, setPdfLoading] = useState(false);

    Font.register({ family: 'Poppins', src: 'https://fonts.gstatic.com/s/poppins/v21/pxiEyp8kv8JHgFVrFJA.ttf' });

    // PDF Styles
    const pdfStyles = StyleSheet.create({
        title: { fontFamily: 'Poppins', fontWeight: 700, color: '#3C5063' },
        text: { fontFamily: 'Poppins', fontWeight: 700, color: '#3C5063', fontSize: 10 },
        textUnderline: { fontFamily: 'Poppins', fontWeight: 700, color: '#3C5063', fontSize: 12, textDecoration: 'underline' },
        page: { flexDirection: 'column', backgroundColor: '#E4E4E4' },
        section: { marginLeft: '30px', marginRight: '30px', paddingTop: '35px', paddingBottom: '25px' },
        image: { width: '100%', maxHeight: '70vh', marginVertical: 10 },
        imageCont: { maxHeight: '75vh', maxWidth: '100vw' },
        detailsSection: { paddingLeft: 3, paddingRight: '130px', marginTop: '20px', },
        singleOutcome: { marginTop: 10 },
        logo: { width: 100, position: 'absolute', top: '30px', right: 0 },
        footer: { position: 'absolute', top: '91vh', left: 0, maxWidth: '100vw' },
        footerText: { fontSize: '8pt', color: '#5c5c5c' }
    });

    // The PDF document component
    const PdfDocument = ({ groupReportChart }) => (
        <Document>
            <Page size="A4">
                <View style={pdfStyles.section}>
                    <Image style={pdfStyles.logo} src={require('../../assets/SCP-logo.jpg')} />

                    <View style={pdfStyles.detailsSection}>
                        <Text style={pdfStyles.text}>School: {selectedSchool && selectedSchool.name && selectedSchool.name}</Text>

                        {selectedYearGroup && selectedYearGroup.year &&
                            <Text style={pdfStyles.text}>Year group: {selectedYearGroup.year}</Text>
                        }

                        {selectedStudentStatuses && selectedStudentStatuses.length > 0 &&
                            <Text style={pdfStyles.text}>Student statuses:
                                {selectedStudentStatuses && selectedStudentStatuses[0] && selectedStudentStatuses.map((selectedStatus, index) =>
                                    <>
                                        <Text style={pdfStyles.text}> {selectedStatus.name} {index !== selectedStudentStatuses.length - 1 && ', '}</Text>
                                    </>
                                )}
                            </Text>
                        }

                        {selectedInverventionTypes && selectedInverventionTypes.length > 0 &&
                            <Text style={pdfStyles.text}>Intervention type:
                                {selectedInverventionTypes && selectedInverventionTypes[0] && selectedInverventionTypes.map((selectedType, index) =>
                                    <>
                                        <Text style={pdfStyles.text}> {selectedType.name} {index !== selectedInverventionTypes.length - 1 && ', '}</Text>
                                    </>
                                )}
                            </Text>
                        }

                        {includeLowAttendance && <Text style={pdfStyles.text}>Attendance: Includes Low Attendance students</Text>}

                        {selectedTutorGroupLead && selectedTutorGroupLead.name && <Text style={pdfStyles.text}>Tutor Group Lead: {selectedTutorGroupLead.name}</Text>}

                        {selectedTutorGroup && selectedTutorGroup.name && <Text style={pdfStyles.text}>Tutor Group: {selectedTutorGroup.name}</Text>}

                        <Text style={pdfStyles.text}>Reporting Periods -
                            {selectedPeriods && selectedPeriods[0] && selectedPeriods.map((selectedPeriod, index) =>
                                <Text style={pdfStyles.text}> {selectedPeriod.period_name} {selectedPeriod.calendar_year} {index !== selectedPeriods.length - 1 && ', '}</Text>
                            )}
                        </Text>

                    </View>

                    <View style={pdfStyles.imageCont}>
                        {groupReportChart && <Image style={pdfStyles.image} src={groupReportChart} />}
                    </View>

                    <View style={pdfStyles.footer}>
                        <Text style={pdfStyles.footerText}>School Consultancy Programme is part of Tutor Your Child Ltd (registered 13378546). Assessments results are calculated by analysing the assessment information available to us at the time using our experience and qualifications. This may not represent the views of all agencies or individuals, and should be used in conjunction with other information available.</Text>
                    </View>
                </View>
            </Page>
        </Document>
    );

    // Capture the image and handle download
    const handleDownload = async () => {
        setPdfLoading(true);
        try {
            const imgUrl = await toPng(groupReportChartRef.current, { backgroundColor: 'white', pixelRatio: 2, quality: 1, cacheBust: true });
            const blob = await pdf(<PdfDocument groupReportChart={imgUrl} />).toBlob();
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'complex_components.pdf';
            link.click();
            URL.revokeObjectURL(link.href);
        } catch (error) {
            console.error('Error generating PDF:', error);
        } finally {
            setPdfLoading(false);
        }
    }

    return (
        <button className='pdfButton' dissabled={pdfLoading} onClick={handleDownload}>
            {pdfLoading ? 'Generating PDF...' : 'Download PDF'}
        </button>
    )
}

export default GroupReportsPDF;